module.exports = __webpack_public_path__ + "img/icon-ecosystem-black.552b4da6.svg";